import Vue                  from "vue";
import Vuex                 from "vuex";
import createPersistedState from "vuex-persistedstate";
import checkout             from "./modules/checkout.js";
import user                 from "./modules/user.js";
import shipping             from "./modules/shipping.js";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    strict: debug,
    
    state: {
        showModal: false,
        modalData: null,
        siteUrl: "",
        cfReady: false // Cookie First ready -> send GA analytics
    },
    
    actions: {
        toggleModal({ commit }, payload) {
            commit("TOGGLE_MODAL", payload);
        },
    
        saveSiteUrl({ commit }, url) {
            commit('SAVE_SITE_URL', url);
        },
        
        setCfReady({ commit }) {
            commit('SET_CF_READY');
        }
    },
    
    mutations: {
        TOGGLE_MODAL(state, payload) {
            state.showModal = payload?.componentName || false;
            state.modalData = payload?.modalData || null;
        },
    
        SAVE_SITE_URL(state, url) {
            state.siteUrl = url;
        },
    
        SET_CF_READY(state) {
            state.cfReady = true;
        }
    },
    
    modules: {
        checkout,
        user,
        shipping
    },
    
    plugins: [
        createPersistedState({
            paths: [
                "user.user",
                "user.email",
                "user.userExists",
                "user.userLoggedIn",
                "checkout.cart",
                "checkout.cart.shippingAddress",
                "checkout.cart.billingAddress",
                "checkout.cart.pickUpLocation",
                "checkout.cart.shippingMethod",
                "shipping.countries"
            ]
        })
    ]
});
